import { useQuery } from '@tanstack/react-query'

import { api } from './api.js'
import * as Auth from './auth.js'

/** Returns the signed-in wallet account's Credits balance. */
export function useCreditsBalance(options: { enabled: boolean }) {
  const address = Auth.useSessionAddress()
  return useQuery({
    enabled: options.enabled,
    queryFn: async () => {
      const res = await api.api.coinflow.balances.$get({ query: { wallet: address! } })
      if (!res.ok) {
        const body = (await res.json().catch(() => null)) as { error?: string } | null
        throw new Error(body?.error ?? 'Failed to load credit balance.')
      }
      return (await res.json()) as { credits: { cents: number } }
    },
    queryKey: Auth.session.queryKey(address, 'coinflow', 'balance'),
  })
}

export function formatCreditCents(cents: number, currency = 'USD') {
  return new Intl.NumberFormat('en-US', {
    currency,
    style: 'currency',
  }).format(cents / 100)
}
